import { gql } from 'graphql-tag';

export const syncedResourceAllocationFragment = gql`
  fragment SyncedResourceAllocation on ResourceAllocation {
    id
    totalHours
    scheduleRules {
      dateRange {
        startDate
        endDate
      }
      do
    }
    startDate
    endDate
  }
`;

export default syncedResourceAllocationFragment;
